export default __webpack_public_path__ + "media/images/logo/media/nikkin-a8e4b0021bddb48056db22d70d4405f0.jpg";